import { render, staticRenderFns } from "./Black.vue?vue&type=template&id=26f656e4&scoped=true&"
import script from "./Black.vue?vue&type=script&lang=ts&"
export * from "./Black.vue?vue&type=script&lang=ts&"
import style0 from "./Black.vue?vue&type=style&index=0&id=26f656e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f656e4",
  null
  
)

export default component.exports